module.exports = __webpack_public_path__ + "img/idea-plan.71a8b512.svg";